<template>
    <!-- 司机-司机任务-统计-审核 -->
    <el-dialog
        title="司机任务审核"
        :visible.sync="show"
        :before-close="closeDialog"
        style="width: 80%; margin: 0 auto"
        append-to-body
        :close-on-click-modal="false"
    >
        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form label-width="50px">
                <!-- <div style="display: flex">
                    <div v-for="(item, index) in data.loop_list" :key="index" style="width: 50%">
                        <el-form-item label="时间段:" label-width="120px">
                            {{ item.loop_time }}
                        </el-form-item>

                        <el-form-item label="完成订单:" label-width="120px">
                            {{ item.condition_order_sum }}
                        </el-form-item>
                        <el-form-item label="在线时长:" label-width="120px">
                            {{ item.condition_time_sum }}
                        </el-form-item>
                        <el-form-item label="在线支付:" label-width="120px">
                            {{ item.condition_online_pay_sum }}
                        </el-form-item>
                    </div>
                </div> -->
                <!-- 添加任务的时候如果勾选司机招募，则这里展示司机招募图片，否则不展示 勾选司机招募，循环里面只有一行数据且司机招募为0/0 添加任务的时候没设置司机招募 -->
                <el-form-item
                    label="司机招募:"
                    label-width="120px"
                    v-if="data.loop_list.length == 1 && data.loop_list[0].condition_recruitment_sum != '0/0'"
                >
                    <!-- <el-form-item
                    label="司机招募:"
                    label-width="120px"
                    
                > -->
                    <!-- {{ data.condition_recruitment_sum }} -->

                    <!-- <el-button @click="getImages">查看</el-button> -->
                    <div v-if="driverImages.length > 0" style="height:500px;overflow-y:auto">
                        <el-image
                            :preview-src-list="srcList"
                            v-for="(val, index) in driverImages"
                            :key="index"
                            style="width: 100px; height: 100px; margin-right: 10px"
                            :src="val"
                        ></el-image>
                    </div>

                    <span v-if="driverImages.length == 0">暂无图片</span>
                </el-form-item>

                <el-form-item label="备注:" label-width="120px">
                    <el-input type="textarea" autosize v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder">
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="display: flex; justify-content: center">
                <el-button type="primary" @click="onSubmitDig('1')">通过</el-button>
                <el-button type="danger" @click="onSubmitDig('2')">拒绝</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.submit_data.driver_task_code = _this.data.driver_task_code;
            _this.search_data.driver_task_code = _this.data.driver_task_code;
            _this.submit_data.driver_task_statistic_code = _this.data.driver_task_statistic_code;
            _this.submit_data.driver_code = _this.data.driver_code;
            _this.search_data.driver_code = _this.data.driver_code;
            _this.search_data.receipt_date = _this.data.receipt_date;
            _this.submit_data.reward_status = _this.data.reward_status;
            if (_this.data.loop_list[0].condition_recruitment_sum != '0/0') {
                // 如果设置了司机招募则获取照片
                _this.getImages();
            }
        }
    },
    data() {
        return {
            show: false,
            srcList: [],
            driverImages: [],

            // 表单数据
            submit_data: {
                driver_task_code: '',
                driver_task_statistic_code: '',
                driver_code: '',
                reward_status: '',
                remarks: ''
            },
            search_data: {
                page: 1,
                limit: 10,
                driver_task_code: '',
                driver_code: '',
                receipt_date: ''
            },

            submit_rules: {
                remarks: {
                    placeholder: '请输入备注',
                    rules: {
                        required: false,
                        message: '备注2-10字之间',
                        regulation: 'between_str',
                        rulesData: [2, 10]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.srcList = [];
            _this.driverImages = [];
            _this.submit_rules.remarks.rules.required = false;

            _this.submit_data = {
                driver_task_code: '',
                driver_task_statistic_code: '',
                driver_code: '',
                reward_status: '',
                remarks: ''
            };
        },
        // 获取司机招募司机端上传的照片
        getImages() {
            _this.srcList = [];
            _this.driverImages = [];
            _this.driverTaskViewImage();
        },
        driverTaskViewImage() {
            _this
                .$post('/task_new/driverTaskViewImage', _this.search_data)
                .then((res) => {
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            _this.srcList.push(res.data[i].img_url);
                            _this.driverImages.push(res.data[i].img_url);
                        }
                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page++;
                            _this.driverTaskViewImage();
                        }
                    }
                })
                .catch((err) => {});
        },

        // 提交按钮
        onSubmitDig(status) {
            _this.submit_data.reward_status = status;
            if (status == '2') {
                // 拒绝，备注是必填项
                _this.submit_rules.remarks.rules.required = true;
            } else {
                _this.submit_rules.remarks.rules.required = false;
            }

            _this
                .$post('/task_new/driverTaskNewReward', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
